// extracted by mini-css-extract-plugin
export var banner = "_q0-0";
export var settingRow = "_q0-2";
export var titleIcon = "_q0-1";